module.exports = __webpack_public_path__ + "static/img/xiamen.0291f36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xiamen.jpg
// module id = i3X5
// module chunks = 1